const allowedDomains = [
  'com',
  'edu',
  'org',
  'net',
  'us',
  'biz',
  'build',
  'co',
  'glass',
  'ca'
];

const emailFormatRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
const emailFormatMessage = 'The email address must be in the correct format.';
const emailDomainMessage = `Incorrect domain format. Allowed domains: ${allowedDomains.map(d => `.${d}`).join(', ')}`;

const emailValidationRules = (isRequiredEmail = true) => {
  return {
    ...(isRequiredEmail && {
      required: 'This field is required.',
    }),
    validate: {
      format: value => {
        if (!value) return !isRequiredEmail || 'This field is required.';
        return emailFormatRegex.test(value) || emailFormatMessage;
      },
      domain: value => {
        if (!value) return !isRequiredEmail || 'This field is required.';
        const domain = value.split('.').pop().toLowerCase();
        return allowedDomains.includes(domain) || emailDomainMessage;
      }
    }
  };
}

export default emailValidationRules;
